var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwitchCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,5.5H17.30859L17,4.88184A2.487,2.487,0,0,0,14.76367,3.5H9.23633A2.487,2.487,0,0,0,7,4.88184L6.69141,5.5H4A2.50263,2.50263,0,0,0,1.5,8V18A2.50263,2.50263,0,0,0,4,20.5H20A2.50263,2.50263,0,0,0,22.5,18V8A2.50263,2.50263,0,0,0,20,5.5ZM21.5,18A1.50164,1.50164,0,0,1,20,19.5H4A1.50164,1.50164,0,0,1,2.5,18V8A1.50164,1.50164,0,0,1,4,6.5H7a.50021.50021,0,0,0,.44727-.27637l.44726-.89453A1.492,1.492,0,0,1,9.23633,4.5h5.52734a1.492,1.492,0,0,1,1.3418.8291l.44726.89453A.50021.50021,0,0,0,17,6.5h3A1.50164,1.50164,0,0,1,21.5,8ZM8,13.5a.49971.49971,0,0,1-.5-.5,4.49435,4.49435,0,0,1,7.40039-3.43408V8.7998a.5.5,0,0,1,1,0v2a.49971.49971,0,0,1-.5.5h-2a.5.5,0,0,1,0-1H14.217A3.49273,3.49273,0,0,0,8.5,13,.49971.49971,0,0,1,8,13.5Zm8.5-.5a4.49435,4.49435,0,0,1-7.40039,3.43408v.76612a.5.5,0,0,1-1,0v-2a.49971.49971,0,0,1,.5-.5h2a.5.5,0,0,1,0,1H9.783A3.49273,3.49273,0,0,0,15.5,13a.5.5,0,0,1,1,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchCamera);
export default __webpack_public_path__ + "static/media/switch-camera.fb89b4f7ac2aa10475e9c385f300296b.svg";
export { ForwardRef as ReactComponent };